import * as React from 'react'
import { CustomerChannelBalanceContextBody } from './types'

export const CustomerChannelBalanceContext = React.createContext<CustomerChannelBalanceContextBody>({
  loading: false,
  refresh: () => {},
})